import { gql } from '@/__generated__';

export const GET_DEVICES = gql(`#graphql
  query Reports_GetDevices($input: DevicesInput!) {
    devices(input: $input) {
      id
      profile {
        id
        name
      }
      metrics {
        availableFields
      }
    }
  }
`);
